<ng-container *ngIf="!isHidden">
  <div
    [matTooltipDisabled]="!tooltipText"
    [matTooltip]="tooltipText"
    matTooltipPosition="above"
    matTooltipShowDelay="300">
    <mat-checkbox
      [disabled]="isDisabled"
      *ngIf="!isIcon"
      color="primary"
      (change)="onChange()"
      [(ngModel)]="isChecked"
    ></mat-checkbox>
  </div>
  <button
    class="adap-btn-grid-cell"
    color="primary"
    *ngIf="isIcon"
    (click)="onIconClick()"
    [matTooltip]="tooltipText"
    matTooltipPosition="above"
    matTooltipShowDelay="300"
  >
    <mat-icon [svgIcon]="icon"></mat-icon>
  </button>
</ng-container>
